import styled, { keyframes } from "styled-components"
import GalleryImageCard from "./components/GalleryImageCard"
import { GALLERYFIRSTDIV, GALLERYSECONDDIV } from "utilities/data"

const ImageGallery = () => {
  return (
    <div className="px-16 max-md:px-0">
      <div className="w-full overflow-x-hidden">
        <Wrapperdiv className=" my-8 flex flex-col justify-center">
          <div className='text-center my-1 whitespace-nowrap'>
            {GALLERYFIRSTDIV.map((imageDiv) => (
              <GalleryImageCard key={imageDiv.id} imageUrl={imageDiv.imageUrl} />
            ))}
          </div>
          <div className='text-center whitespace-nowrap'>
            {GALLERYSECONDDIV.map((imageDiv) => (
              <GalleryImageCard key={imageDiv.id} imageUrl={imageDiv.imageUrl} />
            ))}
          </div>
        </Wrapperdiv>
      </div>
    </div>
  )
}

export default ImageGallery

const sunrise = keyframes`
 /* from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-10vw);
  } */
   from {
    transform: translateX(-200px);
  }
  to {
    transform: translateX(-800px);
  }
`
const Wrapperdiv = styled.div`
  animation: 15s linear 0s infinite alternate ${sunrise};
  width: 180%;
  :hover{
    /* animation-play-state: paused; */
  }
`;